// extracted by mini-css-extract-plugin
module.exports = {"good":"good-rQfeh1ZU","change":"change-R4680DBB"};